// extracted by mini-css-extract-plugin
export default {"jumnotron":"Jumbotron_jumnotron__hbGxy","jumnotron__overlay":"Jumbotron_jumnotron__overlay__W0Myb"};